import brandSpriteUrl from "../assets/brand.svg";

export type BrandTone = "dark" | "light";
export type BrandSymbol = "lockup" | "mark";

interface BrandGraphicOptions {
  className?: string;
  label?: string;
  symbol?: BrandSymbol;
  tone: BrandTone;
}

export function brandGraphicMarkup({
  className,
  label,
  symbol = "lockup",
  tone,
}: BrandGraphicOptions): string {
  const classes = ["brand-graphic", `brand-graphic--${symbol}`, `brand-graphic--${tone}`];
  if (className !== undefined) classes.push(className);
  const accessibility =
    label === undefined
      ? 'aria-hidden="true"'
      : `role="img" aria-label="${escapeAttribute(label)}"`;

  return `<svg class="${classes.join(" ")}" ${accessibility} focusable="false"><use href="${brandSpriteUrl}#${symbol}"></use></svg>`;
}

export function createBrandGraphic(
  document: Document,
  options: BrandGraphicOptions,
): SVGSVGElement {
  const wrapper = document.createElement("template");
  wrapper.innerHTML = brandGraphicMarkup(options);
  const graphic = wrapper.content.firstElementChild;
  if (!(graphic instanceof SVGSVGElement)) {
    throw new Error("The Groundspark brand graphic could not be created.");
  }
  return graphic;
}

function escapeAttribute(value: string): string {
  return value
    .replaceAll("&", "&amp;")
    .replaceAll('"', "&quot;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;");
}
